import {
  FETCH_SETTLEMENTS_REQUEST,
  FETCH_SETTLEMENTS_SUCCESS,
  FETCH_SETTLEMENTS_FAILURE,
} from "./actionTypes";

const initialState = {
  settlements: [],
  loading: false,
  error: null,
};

const settlementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SETTLEMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SETTLEMENTS_SUCCESS:
      return {
        ...state,
        settlements: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_SETTLEMENTS_FAILURE:
      return {
        ...state,
        settlements: [],
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default settlementReducer;
